<div *ngIf="myPeer">
  <div style="display: flex; align-items: flex-end; margin-bottom: 4px">
    <div *ngIf="myPeer.image" class="image cover" [style.background-image]="'url(' + myPeer.image.url + ')' | safe: 'style' "
      (click)="changeIcon()">
      <!--<img *ngIf="myPeer.image" [src]="myPeer.image.url | safe: 'resourceUrl'" />-->
    </div>
    <div>
      <button (click)="changeIcon()">プレイヤーアイコン変更</button>
    </div>
  </div>
  <span>あなたの色とニックネーム：<input type="color" style="width:1em; margin-right: 0.5em" [(ngModel)]="myPeerColor">　<input [(ngModel)]="myPeerName" [style.color]="myPeerColor" style="font-weight: bolder;" placeholder="ニックネーム" />
  <br>※最後に使った色とニックネームをブラウザに保存、<br>　色を初期値に戻す際は白(255,255,255)を選択。</span>
</div>
<div>
  <span>あなたのID：<span>
    <ng-container *ngIf="networkService.isOpen">
      <span style="display: inline-block;">
        <span #idSpacer class="id-spacer">{{ networkService.peerContext.userId }}</span>
        <input #idInput class="id-input" type="text" value="{{ networkService.peerContext.userId }}" readonly>
      </span>
      <button *ngIf="isAbleClipboardCopy" (click)="copyPeerId()" [disabled]="isCopied"><b class="material-icons" style="font-size: 1em; vertical-align: bottom">content_copy</b></button>
      <span [@fadeInOut]="isCopied" class="copied" [style.color]="myPeerColor"> {{ isCopied ? 'クリップボードにコピーしました。' : '' }}</span>
    </ng-container>
  </span>
  <span *ngIf="!networkService.isOpen" style="font-weight: bold;">???</span>
  </span>
</div>
<!--<div>host ID:{{networkService.hostPeerID}}</div>-->
<ng-container *ngIf="networkService.peerContext.isRoom">
  <hr/>
  <div>
    <span>ルーム名：<span *ngIf="networkService.isOpen" style="font-weight: bold;">{{networkService.peerContext.roomName}}/{{networkService.peerContext.roomId}}</span></span>
  </div>
  <div>
    <span>パスワード：<span *ngIf="networkService.isOpen" style="font-weight: bold;">{{networkService.peerContext.password}}</span></span>
  </div>
</ng-container>
<hr/>
<div *ngFor="let context of networkService.peerContexts">
  <div>
    <span *ngIf="!context.isOpen">[接続中]</span>
    <span>他の参加者：{{findUserId(context.peerId)}} [<b [style.color]="findPeerColor(context.peerId)">{{findPeerName(context.peerId)}}</b>]</span>
  </div>
</div>
<div>
  <ng-container *ngIf="!networkService.peerContext.isRoom">
    <input [(ngModel)]="targetUserId" placeholder="接続したい相手のID" name="targetUserId" />
    <button (click)="connectPeer()" [disabled]="!networkService.isOpen || targetUserId == null || targetUserId == ''">プライベート接続</button><br>
  </ng-container>
  <button *ngIf="networkService.peerIds.length <= 1" (click)="showLobby()" [disabled]="!networkService.isOpen">ロビー（ルーム一覧）を表示</button>
</div>
<div><span style="font-size: 12px;">{{help}}</span></div>
<ng-container *ngIf="!networkService.peerContext.isRoom">
  <div style="font-size: 12px;" *ngIf="networkService.peerContexts.length < 1">※プライベート接続を使用する場合は、お互いのIDをユドナリウム外で共有してください。</div>
  <div style="font-size: 12px;" *ngIf="networkService.peerContexts.length < 1">※一人で動作確認を行いたい場合はブラウザを2つ開くと良いと思います。</div>
</ng-container>
<ng-container *ngIf="networkService.peerContext.isRoom">
  <div style="font-size: 12px;">※ルーム機能を利用している時はプライベート接続を利用できません。</div>
</ng-container>
